import { State, Action, StateContext, Selector } from '@ngxs/store';

import {
  Logged,
  Logout,
  Login,
  LoggedOut,
  DispatchAnalyticsEvent,
  Configured,
  Register,
  ConfigureAuth,
  LoadConfiguration
} from './core.actions';
import { SecurityService } from './services/security/security.service';
import {IConfiguration} from './models/configuration.model';

export interface CoreStateModel {
  configuration: IConfiguration;
  authenticated: boolean;
  userData: any;
  isReady: boolean;
}

const defaults: CoreStateModel = {
  configuration: null,
  authenticated: false,
  userData: null,
  isReady: false
};

@State<CoreStateModel>({
  name: 'core',
  defaults: defaults
})
export class CoreState {
  constructor(
    private securityService: SecurityService
  ) {
  }
  //#region Selectors
  @Selector()
  static configuration(state: CoreStateModel) {
    return state.configuration;
  }
  @Selector()
  static authenticated(state: CoreStateModel) {
    return state.authenticated;
  }
  @Selector()
  static userData(state: CoreStateModel) {
    return state.userData;
  }
  @Selector()
  static isReady(state: CoreStateModel) {
    return state.isReady;
  }
  //#endregion

  //#region Authentication
  /** Login Command */
  @Action(Login)
  login() {
    this.securityService.Authorize();
  }

  /** Register Command */
  @Action(Register)
  register({ getState }: StateContext<CoreStateModel>) {
    const state = getState();
    this.securityService.Register(state.configuration.identityUrl,
      state.configuration.clientId, state.configuration.scope);
  }

  /** Logout Command */
  @Action(Logout)
  logout({ getState }: StateContext<CoreStateModel>) {
    const state = getState();
    this.securityService.Logoff(state.configuration.identityUrl);
  }

  /** Logged Event */
  @Action(Logged)
  logged({ patchState }: StateContext<CoreStateModel>,
         { payload }: Logged) {
    patchState({
      authenticated: true,
      userData: payload
    });
    sessionStorage.removeItem('hash');
  }

  /** Logged Out Event */
  @Action(LoggedOut)
  loggedOut({ patchState }: StateContext<CoreStateModel>) {
    patchState({
      authenticated: false,
      userData: null
    });
  }
  /** ConfigureAuth Event */
  @Action(ConfigureAuth)
  configureAuth({ getState }: StateContext<CoreStateModel>) {
    const state = getState();

    this.securityService.ConfigureAuth(state.configuration.identityUrl,
      state.configuration.clientId, state.configuration.scope);
  }
  //#endregion

  /** Load Configuration Command */
  @Action(LoadConfiguration)
  loadConfiguration(
    { patchState }: StateContext<CoreStateModel>,
    { payload }: LoadConfiguration
  ) {
    patchState({
      configuration: payload
    });
  }

  /** dispatchAnalyticsEvent Command */
  @Action(DispatchAnalyticsEvent)
  dispatchAnalyticsEvent({ }: StateContext<CoreStateModel>, { payload }: DispatchAnalyticsEvent) {
    (window as any).ga('send', 'event', {
      eventCategory: payload.eventCategory,
      eventLabel: payload.eventLabel,
      eventAction: payload.eventAction,
      eventValue: payload.eventValue
    });
  }

  /** configured Command */
  @Action(Configured)
  configured({ patchState }: StateContext<CoreStateModel>) {
    patchState({
      isReady: true
    })
  }
}
